import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import 'whatwg-fetch';
import { v4 as uuidv4 } from 'uuid';
import { FieldTitle } from 'react-admin';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, ContentState, convertFromHTML, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import constants from './../../shared/constants';
import { getAuthApp } from '../../services/security/authApp';
import { decrypt } from '../../services/security/encryptorHandlerSecurity';
import UserHelper from '../../helpers/UserHelper';
export class RichTextInputImage extends Component {

    constructor (props) {
        super(props);
        this.state = {
            editorState: EditorState.createEmpty()
        };

        this.onEditorStateChange = this.onEditorStateChange.bind(this);
    }

    onEditorStateChange(editorState) {
        const { input: { onChange } } = this.props;
        this.setState({
            editorState,
        });
        onChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    };

    componentDidMount () {
        if (this.props.input.value) {
            this.setState({
                editorState: EditorState.createWithContent(
                    ContentState.createFromBlockArray(
                      htmlToDraft(this.props.input.value).contentBlocks
                    )
                )
            });
        }
    }
    
    handleSaveImage = async (file) => {
        const typeFile = file.type.split('/')[1];
        const nameImage = `${uuidv4()}.${typeFile}`;
        const v = await UserHelper.validateLocal();
        const user = typeof v === 'string' && v !== null ? JSON.parse(decrypt(localStorage.getItem(v))) : null;
        const url = `${constants.general.serverURL}/api/attachments/cover/download/` + encodeURIComponent(file.name);
        const image = new FormData();
        image.append('file', file);
        image.append('name', file.name);
        const QUERY = '/attachments/cover/upload';

        return fetch(`${constants.general.serverURL}/api${QUERY}?&access_token=${user.id}`, {
            method: 'POST',
            body: image,
            headers: { 
                //'Content-Type': 'application/json', 
                'Content-Type': 'multipart/form-data',
                'Authorization' : getAuthApp()
            }
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Algo salio mal ...');
        })
        .then(data => {
            return(
                {'data': { 'link': url}}
            );
        })
        .catch(error => null);
    };

    render() {

        const { editorState } = this.state;
        const { label, source, isRequired } = this.props;

        return (
            <div style={{
                marginTop: '10px'
            }}>
                <label style={{
                    lineHeight: '22px',
                    pointerEvents: 'none',
                    userSelect: 'none',
                    color: 'rgba(0, 0, 0, 0.3)',
                    fontSize: '13px',
                    marginBottom: '8px',
                    display: 'block'
                }}>
                    <FieldTitle
                        label={label}
                        source={source}
                        isRequired={isRequired}
                    />
                </label>

                <Editor
                    editorState={editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={this.onEditorStateChange}
                    toolbarClassName="toolbar-class"
                    toolbar={{
                        inline: { inDropdown: true },
                        list: { inDropdown: true },
                        textAlign: { inDropdown: true },
                        link: { inDropdown: true },
                        history: { inDropdown: true },
                        image: { uploadCallback: this.handleSaveImage, previewImage: true, alt: { present: true, mandatory: true } },
                    }}
                />
            </div>
        );
    }
}

const CustomRichTextInput = ({ source, label, isRequired }) => (
    <TextField name={source} component={RichTextInputImage} source={source} label={label} validation={{ required: isRequired }} isRequired={isRequired}/>
);

CustomRichTextInput.propTypes = {
    source: PropTypes.string
};

CustomRichTextInput.defaultProps = {
    source: ''
};

export default CustomRichTextInput;
